import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Consulta.css";

export default function Consulta() {
  const [numero, setNumero] = useState("");
  const [isLoadingConsulta, setIsLoadingConsulta] = useState(false);
  const [isLoadingCompra, setIsLoadingCompra] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [msisdn, setMsisdn] = useState("");
  const [options, setOptions] = useState([]);
  const [bananaSaldo, setBananaSaldo] = useState(0);
  const [usarBanana, setUsarBanana] = useState(false);
  const [vendedor, setVendedor] = useState(null);
  const [saldoVendedor, setSaldoVendedor] = useState(null);
  const [usarSaldoVendedor, setUsarSaldoVendedor] = useState(false);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;
  const [searchParams] = useSearchParams();

  // Cargar info de vendedor si está logueado
  useEffect(() => {
    const idv = localStorage.getItem('id_vendedor');
    const nombre = localStorage.getItem('nombre');
    if (idv && idv !== 'undefined' && idv !== 'null') {
      setVendedor({ id: idv, nombre: nombre || '' });
      // Consultar saldo
      axios.post(`${apiUrl}/prod/saldo`, { id_vendedor: idv, app: '1' })
        .then(r => setSaldoVendedor(r.data?.saldo || r.data?.body?.saldo || null))
        .catch(() => {});
    }
  }, [apiUrl]);

  useEffect(() => {
    // Prioridad: query param > localStorage
    const paramMsisdn = searchParams.get('msisdn');
    if (paramMsisdn && /^\d{10}$/.test(paramMsisdn)) {
      setNumero(paramMsisdn);
      doConsulta(paramMsisdn);
    } else {
      const saved = localStorage.getItem("formData");
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.msisdn) { setNumero(parsed.msisdn); doConsulta(parsed.msisdn); }
      }
    }
  }, []);

  const doConsulta = async (num) => {
    const n = num || numero;
    if (!/^\d{10}$/.test(n)) { toast.warn("Número inválido. Debe tener 10 dígitos."); return; }
    setIsLoadingConsulta(true);
    try {
      toast.info("Consultando...", { autoClose: 1500 });
      const data = { msisdn: n, name: "", app: "1", serv: "profile" };
      localStorage.setItem("formData", JSON.stringify(data));
      const response = await axios.post(`https://skeuoyitdc.execute-api.mx-central-1.amazonaws.com/prod/cambaceo_ofertas`, data);
      const d = response.data;
      setApiData(d);
      setOptions((d.info || []).flatMap((i) => i || []));
      setMsisdn(d.msisdn);
      // Consultar saldo banana
      try {
        const bRes = await fetch(`${apiUrl}/prod/banana_wallet`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'saldo', msisdn: d.msisdn }),
        });
        const bData = await bRes.json();
        const bBody = typeof bData.body === 'string' ? JSON.parse(bData.body) : bData.body || bData;
        setBananaSaldo(bBody.saldo || 0);
      } catch { setBananaSaldo(0); }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error al consultar.");
    } finally { setIsLoadingConsulta(false); }
  };

  const handleCompra = async (id_oferta, precio, cashback_pct) => {
    if (!msisdn) { toast.warn("Primero consulta un número."); return; }
    setIsLoadingCompra(true);
    try {
      const precioNum = parseFloat(precio) || 0;
      let descuento = 0;

      // Si usa banana pesos, reservar el descuento
      if (usarBanana && bananaSaldo > 0) {
        descuento = Math.min(bananaSaldo, precioNum);
      }

      const montoFinal = precioNum - descuento;

      if (montoFinal > 0) {
        toast.info("Preparando tu compra...", { autoClose: 1500 });
        // Guardar info de banana pesos para el webhook
        if (descuento > 0) {
          localStorage.setItem('banana_pendiente', JSON.stringify({ msisdn, descuento, oferta_id: id_oferta }));
        }
        const response = await axios.post(`${apiUrl}/prod/genera_pago`, {
          msisdn, id_oferta, movil: msisdn, app: "1",
          idvendedor_app: usarSaldoVendedor ? (vendedor?.id || "") : "",
          banana_descuento: descuento > 0 ? descuento : undefined,
          banana_msisdn: descuento > 0 ? msisdn : undefined,
        });
        const api = response.data;
        
        // Acreditar cashback solo si NO usó banana pesos
        if (cashback_pct > 0 && !usarBanana) {
          await fetch(`${apiUrl}/prod/banana_wallet`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'cashback', msisdn, monto_compra: precioNum, oferta_id: id_oferta, cashback_pct }),
          });
          toast.success(`🍌 +$${cashback_pct} banana pesos ganados`);
        }

        if (api.payment_request_id) window.location.href = `https://pago.clip.mx/${api.payment_request_id}`;
        else toast.error("No se pudo generar el pago.");
      } else {
        // Compra cubierta totalmente con banana pesos — NO da cashback
        toast.success("🍌 Compra cubierta con banana pesos. Procesando...");
      }
    } catch { toast.error("Error al generar pago."); }
    finally { setIsLoadingCompra(false); }
  };

  return (
    <div className="consulta-page">

      {/* VENDEDOR BAR */}
      {vendedor && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '10px 16px', background: '#fff', borderRadius: '12px',
          marginBottom: '12px', border: '1px solid #d4e8d6', fontSize: '13px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '16px' }}>👤</span>
            <div>
              <div style={{ fontWeight: 700, color: '#1a3a2a' }}>{vendedor.nombre}</div>
              <div style={{ fontSize: 11, color: '#6b8f71' }}>ID: {vendedor.id}</div>
            </div>
          </div>
          {saldoVendedor !== null && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontWeight: 800, color: '#1a3a2a' }}>${saldoVendedor}</div>
                <div style={{ fontSize: 11, color: '#6b8f71' }}>Saldo</div>
              </div>
              <label style={{ position: 'relative', width: '36px', height: '20px', flexShrink: 0 }}>
                <input type="checkbox" checked={usarSaldoVendedor} onChange={(e) => setUsarSaldoVendedor(e.target.checked)}
                  style={{ opacity: 0, width: 0, height: 0 }} />
                <span style={{
                  position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                  background: usarSaldoVendedor ? '#22c55e' : '#d1d5db', borderRadius: '10px', cursor: 'pointer',
                  transition: 'background 0.2s',
                }} />
                <span style={{
                  position: 'absolute', top: '2px', left: usarSaldoVendedor ? '18px' : '2px',
                  width: '16px', height: '16px', background: '#fff', borderRadius: '50%',
                  transition: 'left 0.2s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
                }} />
              </label>
            </div>
          )}
        </div>
      )}

      {/* HERO + SEARCH */}
      <div className="consulta-hero">
        <h1>📱 Recarga y Consulta tu Saldo</h1>
        <p>Ingresa tu número MonkeyPhone para ver tu saldo y recargar al instante.</p>
        <form className="consulta-search" onSubmit={(e) => { e.preventDefault(); doConsulta(); }}>
          <input
            type="tel"
            maxLength={10}
            placeholder="Tu número (10 dígitos)"
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            required
          />
          <button disabled={isLoadingConsulta}>
            {isLoadingConsulta ? "..." : "Consultar"}
          </button>
        </form>
      </div>

      {/* STATUS */}
      {apiData && (
        <div className="consulta-status">
          <div className="consulta-status-header">
            <span style={{ fontSize: 16, fontWeight: 700, color: '#1b2938' }}>📞 {msisdn}</span>
            <span className={`consulta-status-badge ${/activ/i.test(apiData.estatus) ? 'active' : 'inactive'}`}>
              {apiData.estatus}
            </span>
          </div>
          {(() => {
            const venc = apiData.fecha_vencimiento || '';
            let diasRestantes = null;
            try {
              const parts = venc.match(/(\d{2})-(\d{2})-(\d{4})/);
              if (parts) {
                const fechaVenc = new Date(`${parts[3]}-${parts[2]}-${parts[1]}`);
                diasRestantes = Math.ceil((fechaVenc - new Date()) / (1000 * 60 * 60 * 24));
              }
            } catch {}
            const urgente = diasRestantes !== null && diasRestantes <= 3;
            const pronto = diasRestantes !== null && diasRestantes <= 7 && diasRestantes > 3;
            return (
              <div style={{
                fontSize: 13, marginBottom: 16, padding: urgente || pronto ? '12px 16px' : '0',
                background: urgente ? '#fef2f2' : pronto ? '#fef9c3' : 'transparent',
                borderRadius: 12, borderLeft: urgente ? '4px solid #ef4444' : pronto ? '4px solid #f59e0b' : 'none',
              }}>
                <span style={{ color: '#6b7280' }}>📅 Vence: {venc}</span>
                {diasRestantes !== null && (
                  <span style={{ marginLeft: 8, fontWeight: 700, color: urgente ? '#ef4444' : pronto ? '#f59e0b' : '#6b8f71' }}>
                    {urgente ? `⚠️ ¡${diasRestantes} día${diasRestantes !== 1 ? 's' : ''}! Recarga ahora` :
                     pronto ? `⏰ ${diasRestantes} días restantes` :
                     `(${diasRestantes} días)`}
                  </span>
                )}
              </div>
            );
          })()}
          {bananaSaldo > 0 && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: '12px 16px', background: '#fef9c3', borderRadius: '12px', marginBottom: '16px',
            }}>
              <span style={{ fontSize: '28px' }}>🍌</span>
              <div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: '#92400e' }}>${bananaSaldo.toFixed(2)}</div>
                <div style={{ fontSize: '11px', color: '#a16207' }}>Banana Pesos disponibles</div>
              </div>
            </div>
          )}
          <div className="consulta-usage">
            {apiData.datos !== undefined && (
              <div className="consulta-usage-item">
                <div className="consulta-usage-label">Datos</div>
                <div className="consulta-usage-bar"><div className="consulta-usage-fill" style={{ width: `${Math.min(apiData.datos / 50 * 100, 100)}%` }} /></div>
                <div className="consulta-usage-value">{apiData.datos} GB</div>
              </div>
            )}
            {apiData.sms !== undefined && (
              <div className="consulta-usage-item">
                <div className="consulta-usage-label">SMS</div>
                <div className="consulta-usage-bar"><div className="consulta-usage-fill" style={{ width: `${Math.min(apiData.sms / 2000 * 100, 100)}%` }} /></div>
                <div className="consulta-usage-value">{apiData.sms}</div>
              </div>
            )}
            {apiData.min !== undefined && (
              <div className="consulta-usage-item">
                <div className="consulta-usage-label">Minutos</div>
                <div className="consulta-usage-bar"><div className="consulta-usage-fill" style={{ width: `${Math.min(apiData.min / 5000 * 100, 100)}%` }} /></div>
                <div className="consulta-usage-value">{apiData.min}</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* OFFERS GRID */}
      {options.length > 0 && (
        <>
          {bananaSaldo > 0 && (
            <div style={{
              padding: '16px 18px', background: '#fef9c3', borderRadius: '14px', marginBottom: '16px',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '28px' }}>🍌</span>
                  <div>
                    <div style={{ fontSize: '20px', fontWeight: '800', color: '#92400e' }}>${bananaSaldo.toFixed(2)}</div>
                    <div style={{ fontSize: '11px', color: '#a16207' }}>Banana Pesos</div>
                  </div>
                </div>
                <label style={{ position: 'relative', width: '44px', height: '24px' }}>
                  <input type="checkbox" checked={usarBanana} onChange={(e) => setUsarBanana(e.target.checked)}
                    style={{ opacity: 0, width: 0, height: 0 }} />
                  <span style={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    background: usarBanana ? '#22c55e' : '#d1d5db', borderRadius: '12px', cursor: 'pointer',
                    transition: 'background 0.2s',
                  }} />
                  <span style={{
                    position: 'absolute', top: '2px', left: usarBanana ? '22px' : '2px',
                    width: '20px', height: '20px', background: '#fff', borderRadius: '50%',
                    transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                  }} />
                </label>
              </div>
              <div style={{ fontSize: '12px', color: '#a16207', lineHeight: '1.4' }}>
                {usarBanana ? '✅ Se descontará de tu próxima compra' : 'Activa el switch para usar tus banana pesos en tu recarga'}
              </div>
              <div style={{ fontSize: '11px', color: '#ca8a04', marginTop: '4px' }}>
                💡 Compra ofertas desde $200 y gana banana pesos en cada recarga
              </div>
            </div>
          )}
          {/* Botón Mi Grupo */}
          <button onClick={() => navigate('/Grupo')} style={{
            width: '100%', padding: '12px', marginBottom: '16px',
            background: '#fff', border: '2px solid #d4e8d6', borderRadius: '14px',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            fontSize: '14px', fontWeight: '600', color: '#1a3a2a',
          }}>
            👨‍👩‍👧‍👦 {localStorage.getItem('grupo_admin') ? 'Ver mi grupo' : 'Crear grupo familiar/empresa'}
          </button>

          {/* Botón Registrar IMEI */}
          <a href="/vinculacion" style={{
            width: '100%', padding: '12px', marginBottom: '16px',
            background: '#fff', border: '2px solid #d4e8d6', borderRadius: '14px',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            fontSize: '14px', fontWeight: '600', color: '#1a3a2a', textDecoration: 'none', boxSizing: 'border-box',
          }}>
            📱 Vincula tu línea (Registro de número)
          </a>

          <h3 className="consulta-offers-title">Ofertas disponibles para ti</h3>
          <div className="consulta-grid">
            {options.map((item) => {
              const desc = item.descripcion_oferta_comercial || '';
              const features = [];
              const gbMatches = desc.match(/(\d+)\s*GB/gi);
              if (gbMatches && gbMatches.length >= 2) {
                const gb1 = gbMatches[0].match(/\d+/)[0];
                const gb2 = gbMatches[1].match(/\d+/)[0];
                features.push(`${gb1} GB alta velocidad`);
                features.push(`${gb2} GB velocidad media`);
                features.push(`${parseInt(gb1) + parseInt(gb2)} GB totales`);
              } else if (gbMatches) {
                features.push(`${gbMatches[0].match(/\d+/)[0]} GB de datos`);
              }
              if (/ilimitad/i.test(desc) && /min/i.test(desc)) features.push('Minutos ilimitados');
              else { const minMatch = desc.match(/(\d+)\s*min/i); if (minMatch) features.push(`${minMatch[1]} Minutos`); }
              const smsMatch = desc.match(/(\d+)\s*sms/i);
              if (smsMatch) features.push(`${smsMatch[1]} SMS`);
              if (/redes\s*soc/i.test(desc)) features.push('Redes Sociales');
              if (/hot\s*spot/i.test(desc) && !/no\s*hot\s*spot/i.test(desc)) features.push('HotSpot');
              features.push('Roaming USA y Canadá');
              const diasMatch = desc.match(/(\d+)\s*[Dd][ií]as?/);

              return (
                <div className="consulta-card" key={item.idoferta_app}>
                  <p className="consulta-card-name">{item.nombre_comercial || 'Oferta'}</p>
                  <p className="consulta-card-price">
                    {usarBanana && bananaSaldo > 0 ? (
                      <>
                        <span style={{ textDecoration: 'line-through', color: '#9ca3af', fontSize: '18px', marginRight: '8px' }}>
                          ${item.precio_minorista}
                        </span>
                        ${Math.max(parseFloat(item.precio_minorista) - bananaSaldo, 0).toFixed(0)}
                      </>
                    ) : (
                      <>${item.precio_minorista}</>
                    )}
                    <span className="mxn">MXN</span>
                    {parseFloat(item.cashback_pct) > 0 && (
                      <span style={{ fontSize: '12px', fontWeight: '600', color: '#92400e', marginLeft: '8px' }}>
                        🍌 +${item.cashback_pct}
                      </span>
                    )}
                  </p>
                  <p className="consulta-card-days">{diasMatch ? `${diasMatch[1]} días por línea` : '30 días por línea'}</p>
                  <ul className="consulta-card-features">
                    {features.map((f, i) => <li key={i}>{f}</li>)}
                  </ul>
                  <button
                    className="consulta-card-btn"
                    onClick={() => handleCompra(item.idoferta_app, item.precio_minorista, parseFloat(item.cashback_pct) || 0)}
                    disabled={isLoadingCompra}
                  >
                    {isLoadingCompra ? "Procesando..." : "Comprar"}
                  </button>
                </div>
              );
            })}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={4000} />
    </div>
  );
}
